import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addErrorMessageAction, setTaskFulfilled, setTaskPending } from '../actions';

const useAsyncQuery = (fetchFn, { initialData = null, condition = true } = {}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(initialData);

  const reqIdRef = useRef(0);
  const settledRef = useRef(true);

  useEffect(() => {
    if (!condition) {
      return undefined;
    }

    let canceled = false;
    reqIdRef.current += 1;
    const reqId = reqIdRef.current;
    settledRef.current = false;

    const run = async () => {
      dispatch(setTaskPending());
      try {
        const result = await fetchFn();
        if (!canceled && reqId === reqIdRef.current) setData(result);
      } catch (err) {
        if (!canceled && reqId === reqIdRef.current) {
          dispatch(addErrorMessageAction(err));
        }
      } finally {
        if (!canceled && reqId === reqIdRef.current) {
          dispatch(setTaskFulfilled());
          settledRef.current = true;
        }
      }
    };

    run();

    return () => {
      canceled = true;
      if (!settledRef.current && reqId === reqIdRef.current) {
        dispatch(setTaskFulfilled());
      }
    };
  }, [fetchFn, condition]);

  return data;
};

export default useAsyncQuery;
